module.exports = __webpack_public_path__ + "static/img/4.bf0b8a87.jpg";